export const faqData = [
  {
    id: 1,
    question: "What is a Car Loan EMI Calculator?",
    answer:
      "A car loan EMI calculator helps you estimate your monthly loan repayment based on the loan amount, interest rate, and tenure.",
  },
  {
    id: 2,
    question: "How Can I Reduce My EMI for a Car Loan?",

    answerList: [
      {
        info: "Opt for a longer loan tenure.",
      },
      {
        info: "Negotiate a lower interest rate.",
      },
      {
        info: "Make a larger down payment to reduce the loan amount.",
      },
      {
        info: "Consider refinancing your car loan if better options are available.",
      },
    ],
  },
  {
    id: 3,
    question:
      "What is the Difference Between Interest Rates for New and Used Cars?",
    answer:
      "New cars generally have lower interest rates (starting from 8.50%) as they are considered less risky for lenders. Used cars often attract higher rates (starting from 10.75%) due to greater depreciation and resale uncertainties.",
  },
  {
    id: 4,
    question: "What Factors Affect Car Loan EMI?",
    answerList: [
      {
        head: "Loan Amount: ",
        info: "Higher amounts result in higher EMIs.",
      },
      {
        head: "Interest Rate: ",
        info: "A lower interest rate reduces your EMI.",
      },
      {
        head: "Loan Tenure: ",
        info: "A longer tenure reduces the EMI but increases total interest.",
      },
    ],
  },
  {
    id: 5,
    question: "Can I Make Prepayments on My Car Loan?",
    answer:
      "Yes, prepayments can reduce either the EMI or the tenure of your car loan. However, check with Kotak Mahindra Bank for prepayment penalties.",
  },
  {
    id: 6,
    question: "What Documents Are Required for a Car Loan?",
    answer: "Typical documents include:",
    answerList: [
      {
        info: "Identity proof (Aadhaar, PAN, etc.)",
      },
      {
        info: "Address proof (utility bills, rental agreement, etc.)",
      },
      {
        info: "Income proof (salary slips, bank statements, etc.)",
      },
      {
        info: "Car invoice and RC book.",
      },
    ],
  },
  {
    id: 7,
    question: "Can I Get a Car Loan with a Low Credit Score?",
    answer:
      "It may be possible, but a low credit score could result in higher interest rates. Improving your credit score can help you get better terms.",
  },
  {
    id: 8,
    question:
      "How Do I Choose Between Fixed and Floating Interest Rates for a Car Loan?",
    answerList: [
      {
        head: "Fixed Rates: ",
        info: "Remain constant throughout the tenure, providing stability.",
      },
      {
        head: "Floating Rates: ",
        info: "May fluctuate based on market conditions, offering potential savings if rates decrease.",
      },
    ],
  },
];
